/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <!-- Left: version + switcher + task checklist -->
      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">

        <div class="flex gap-2 mb-2">
          <vs-button :color="version === 'v1' ? 'warning' : 'grey'" type="filled" class="flex-1" @click="switchVersion('v1')">Version 1</vs-button>
          <vs-button :color="version === 'v2' ? 'warning' : 'grey'" type="filled" class="flex-1" @click="switchVersion('v2')">Version 2</vs-button>
        </div>

        <div class="flex gap-2 mb-2">
          <vs-button :color="selectedRouter === 'r1' ? 'primary' : 'grey'" type="filled" class="flex-1" @click="selectedRouter = 'r1'">R1</vs-button>
          <vs-button :color="selectedRouter === 'r2' ? 'primary' : 'grey'" type="filled" class="flex-1" @click="selectedRouter = 'r2'">R2</vs-button>
        </div>

        <vx-card style="height: 38rem; overflow-y: auto">

          <!-- ── VERSION 1 ── -->
          <template v-if="version === 'v1'">

            <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (v1Task1Done ? '#28C76F' : '#3a3f51') }">
              <div class="flex items-center gap-2 px-3 py-2" :style="{ background: v1Task1Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
                <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: v1Task1Done ? '#28C76F' : '#4a5568' }">1</span>
                <span class="font-semibold text-sm flex-1">R1 — Route to server via R2</span>
                <span class="text-xs font-medium" :class="v1Task1Done ? 'text-success' : 'text-grey'">{{ v1Task1Done ? 1 : 0 }}/1</span>
              </div>
              <div class="px-3 py-2 space-y-1">
                <div class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: v1R1Completion.task1 ? '#28C76F' : 'transparent', border: '2px solid ' + (v1R1Completion.task1 ? '#28C76F' : '#6b7280') }"></div>
                  <code class="text-base" :class="v1R1Completion.task1 ? 'text-success' : ''">ip route 10.0.41.10 255.255.255.255 10.0.12.2</code>
                </div>
              </div>
            </div>

            <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (v1Task2Done ? '#28C76F' : '#3a3f51') }">
              <div class="flex items-center gap-2 px-3 py-2" :style="{ background: v1Task2Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
                <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: v1Task2Done ? '#28C76F' : '#4a5568' }">2</span>
                <span class="font-semibold text-sm flex-1">R2 — Default route to ISP</span>
                <span class="text-xs font-medium" :class="v1Task2Done ? 'text-success' : 'text-grey'">{{ v1Task2Done ? 1 : 0 }}/1</span>
              </div>
              <div class="px-3 py-2 space-y-1">
                <div class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: v1R2Completion.task2 ? '#28C76F' : 'transparent', border: '2px solid ' + (v1R2Completion.task2 ? '#28C76F' : '#6b7280') }"></div>
                  <code class="text-base" :class="v1R2Completion.task2 ? 'text-success' : ''">ip route 0.0.0.0 0.0.0.0 209.165.200.225</code>
                </div>
              </div>
            </div>

            <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (v1Task3Done ? '#28C76F' : '#3a3f51') }">
              <div class="flex items-center gap-2 px-3 py-2" :style="{ background: v1Task3Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
                <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: v1Task3Done ? '#28C76F' : '#4a5568' }">3</span>
                <span class="font-semibold text-sm flex-1">R1 — Backup floating route via R2 (AD 254)</span>
                <span class="text-xs font-medium" :class="v1Task3Done ? 'text-success' : 'text-grey'">{{ v1Task3Done ? 1 : 0 }}/1</span>
              </div>
              <div class="px-3 py-2 space-y-1">
                <div class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: v1R1Completion.task3 ? '#28C76F' : 'transparent', border: '2px solid ' + (v1R1Completion.task3 ? '#28C76F' : '#6b7280') }"></div>
                  <code class="text-base" :class="v1R1Completion.task3 ? 'text-success' : ''">ip route 10.0.41.0 255.255.255.0 10.0.12.2 254</code>
                </div>
              </div>
            </div>

            <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (v1Task4Done ? '#28C76F' : '#3a3f51') }">
              <div class="flex items-center gap-2 px-3 py-2" :style="{ background: v1Task4Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
                <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: v1Task4Done ? '#28C76F' : '#4a5568' }">4</span>
                <span class="font-semibold text-sm flex-1">R1 — Primary route to R4 LAN via R3</span>
                <span class="text-xs font-medium" :class="v1Task4Done ? 'text-success' : 'text-grey'">{{ v1Task4Done ? 1 : 0 }}/1</span>
              </div>
              <div class="px-3 py-2 space-y-1">
                <div class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: v1R1Completion.task4 ? '#28C76F' : 'transparent', border: '2px solid ' + (v1R1Completion.task4 ? '#28C76F' : '#6b7280') }"></div>
                  <code class="text-base" :class="v1R1Completion.task4 ? 'text-success' : ''">ip route 10.0.41.0 255.255.255.0 10.0.13.3</code>
                </div>
              </div>
            </div>

            <div class="rounded-lg mb-2 overflow-hidden" :style="{ border: '1px solid ' + (v1SaveDone ? '#28C76F' : '#3a3f51') }">
              <div class="flex items-center gap-2 px-3 py-2" :style="{ background: v1SaveDone ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
                <feather-icon :icon="v1SaveDone ? 'CheckCircleIcon' : 'CircleIcon'" :svgClasses="v1SaveDone ? 'text-success' : 'text-grey'" size="16" class="flex-shrink-0" />
                <span class="font-semibold text-sm flex-1">Save Configuration</span>
                <span class="text-xs font-medium" :class="v1SaveDone ? 'text-success' : 'text-grey'">{{ [v1R1Completion.saved, v1R2Completion.saved].filter(Boolean).length }}/2</span>
              </div>
              <div class="px-3 py-2">
                <div v-for="rKey in ['r1','r2']" :key="rKey" class="mb-2">
                  <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background: rgba(255,255,255,0.07); letter-spacing: 0.05em">{{ rKey.toUpperCase() }}</span>
                  <div class="space-y-1 ml-1">
                    <div class="flex items-center gap-2">
                      <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: (rKey==='r1' ? r1 : r2).endDone ? '#28C76F' : 'transparent', border: '2px solid ' + ((rKey==='r1' ? r1 : r2).endDone ? '#28C76F' : '#6b7280') }"></div>
                      <code class="text-base" :class="(rKey==='r1' ? r1 : r2).endDone ? 'text-success' : ''">end</code>
                    </div>
                    <div class="flex items-center gap-2">
                      <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: (rKey==='r1' ? v1R1Completion : v1R2Completion).saved ? '#28C76F' : 'transparent', border: '2px solid ' + ((rKey==='r1' ? v1R1Completion : v1R2Completion).saved ? '#28C76F' : '#6b7280') }"></div>
                      <code class="text-base" :class="(rKey==='r1' ? v1R1Completion : v1R2Completion).saved ? 'text-success' : ''">copy running-config startup-config</code>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </template>

          <!-- ── VERSION 2 ── -->
          <template v-else>

            <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (v2Task1Done ? '#28C76F' : '#3a3f51') }">
              <div class="flex items-center gap-2 px-3 py-2" :style="{ background: v2Task1Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
                <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: v2Task1Done ? '#28C76F' : '#4a5568' }">1</span>
                <span class="font-semibold text-sm flex-1">R2 — Default route to ISP</span>
                <span class="text-xs font-medium" :class="v2Task1Done ? 'text-success' : 'text-grey'">{{ v2Task1Done ? 1 : 0 }}/1</span>
              </div>
              <div class="px-3 py-2 space-y-1">
                <div class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: v2R2Completion.task1 ? '#28C76F' : 'transparent', border: '2px solid ' + (v2R2Completion.task1 ? '#28C76F' : '#6b7280') }"></div>
                  <code class="text-base" :class="v2R2Completion.task1 ? 'text-success' : ''">ip route 0.0.0.0 0.0.0.0 209.165.200.225</code>
                </div>
              </div>
            </div>

            <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (v2Task2Done ? '#28C76F' : '#3a3f51') }">
              <div class="flex items-center gap-2 px-3 py-2" :style="{ background: v2Task2Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
                <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: v2Task2Done ? '#28C76F' : '#4a5568' }">2</span>
                <span class="font-semibold text-sm flex-1">R1 — Default route to ISP via R2</span>
                <span class="text-xs font-medium" :class="v2Task2Done ? 'text-success' : 'text-grey'">{{ v2Task2Done ? 1 : 0 }}/1</span>
              </div>
              <div class="px-3 py-2 space-y-1">
                <div class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: v2R1Completion.task2 ? '#28C76F' : 'transparent', border: '2px solid ' + (v2R1Completion.task2 ? '#28C76F' : '#6b7280') }"></div>
                  <code class="text-base" :class="v2R1Completion.task2 ? 'text-success' : ''">ip route 0.0.0.0 0.0.0.0 10.0.12.2</code>
                </div>
              </div>
            </div>

            <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (v2Task3Done ? '#28C76F' : '#3a3f51') }">
              <div class="flex items-center gap-2 px-3 py-2" :style="{ background: v2Task3Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
                <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: v2Task3Done ? '#28C76F' : '#4a5568' }">3</span>
                <span class="font-semibold text-sm flex-1">R2 — Route to server at 10.0.41.10</span>
                <span class="text-xs font-medium" :class="v2Task3Done ? 'text-success' : 'text-grey'">{{ v2Task3Done ? 1 : 0 }}/1</span>
              </div>
              <div class="px-3 py-2 space-y-1">
                <div class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: v2R2Completion.task3 ? '#28C76F' : 'transparent', border: '2px solid ' + (v2R2Completion.task3 ? '#28C76F' : '#6b7280') }"></div>
                  <code class="text-base" :class="v2R2Completion.task3 ? 'text-success' : ''">ip route 10.0.41.10 255.255.255.255 10.0.24.4</code>
                </div>
              </div>
            </div>

            <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (v2Task4Done ? '#28C76F' : '#3a3f51') }">
              <div class="flex items-center gap-2 px-3 py-2" :style="{ background: v2Task4Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
                <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: v2Task4Done ? '#28C76F' : '#4a5568' }">4</span>
                <span class="font-semibold text-sm flex-1">R1 — Route to R4 LAN via R3</span>
                <span class="text-xs font-medium" :class="v2Task4Done ? 'text-success' : 'text-grey'">{{ v2Task4Done ? 1 : 0 }}/1</span>
              </div>
              <div class="px-3 py-2 space-y-1">
                <div class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: v2R1Completion.task4 ? '#28C76F' : 'transparent', border: '2px solid ' + (v2R1Completion.task4 ? '#28C76F' : '#6b7280') }"></div>
                  <code class="text-base" :class="v2R1Completion.task4 ? 'text-success' : ''">ip route 10.0.41.0 255.255.255.0 10.0.13.3</code>
                </div>
              </div>
            </div>

            <div class="rounded-lg mb-2 overflow-hidden" :style="{ border: '1px solid ' + (v2SaveDone ? '#28C76F' : '#3a3f51') }">
              <div class="flex items-center gap-2 px-3 py-2" :style="{ background: v2SaveDone ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
                <feather-icon :icon="v2SaveDone ? 'CheckCircleIcon' : 'CircleIcon'" :svgClasses="v2SaveDone ? 'text-success' : 'text-grey'" size="16" class="flex-shrink-0" />
                <span class="font-semibold text-sm flex-1">Save Configuration</span>
                <span class="text-xs font-medium" :class="v2SaveDone ? 'text-success' : 'text-grey'">{{ [v2R1Completion.saved, v2R2Completion.saved].filter(Boolean).length }}/2</span>
              </div>
              <div class="px-3 py-2">
                <div v-for="rKey in ['r1','r2']" :key="rKey" class="mb-2">
                  <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background: rgba(255,255,255,0.07); letter-spacing: 0.05em">{{ rKey.toUpperCase() }}</span>
                  <div class="space-y-1 ml-1">
                    <div class="flex items-center gap-2">
                      <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: (rKey==='r1' ? r1 : r2).endDone ? '#28C76F' : 'transparent', border: '2px solid ' + ((rKey==='r1' ? r1 : r2).endDone ? '#28C76F' : '#6b7280') }"></div>
                      <code class="text-base" :class="(rKey==='r1' ? r1 : r2).endDone ? 'text-success' : ''">end</code>
                    </div>
                    <div class="flex items-center gap-2">
                      <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: (rKey==='r1' ? v2R1Completion : v2R2Completion).saved ? '#28C76F' : 'transparent', border: '2px solid ' + ((rKey==='r1' ? v2R1Completion : v2R2Completion).saved ? '#28C76F' : '#6b7280') }"></div>
                      <code class="text-base" :class="(rKey==='r1' ? v2R1Completion : v2R2Completion).saved ? 'text-success' : ''">copy running-config startup-config</code>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </template>

        </vx-card>
      </div>

      <!-- Right: Terminals -->
      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command
            v-show="selectedRouter === 'r1'"
            :key="'r1-' + version"
            id="r1_terminal"
            :commands="r1Commands"
            :prompt="r1Prompt"
            :show-intro="true"
            intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands."
            style="background-color: #111111; border: 1px solid #181d2a; border-radius: 0.5rem; height: 100%"
            title="R1"
          />
          <vue-command
            v-show="selectedRouter === 'r2'"
            :key="'r2-' + version"
            id="r2_terminal"
            :commands="r2Commands"
            :prompt="r2Prompt"
            :show-intro="true"
            intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands."
            style="background-color: #111111; border: 1px solid #181d2a; border-radius: 0.5rem; height: 100%"
            title="R2"
          />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP_TEXT =
  'Commands:<br>' +
  '&nbsp;ip route [dest] [mask] [nexthop] [AD]<br>' +
  '&nbsp;show ip route<br>' +
  '&nbsp;show ip interface brief<br>' +
  '&nbsp;copy running-config startup-config<br>' +
  '&nbsp;end | exit<br>';

const IFACE_BRIEF = {
  r1: 'Interface&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;IP-Address&nbsp;&nbsp;&nbsp;OK?&nbsp;Method&nbsp;Status&nbsp;&nbsp;&nbsp;Protocol<br>' +
      'GigabitEthernet0/0&nbsp;&nbsp;10.0.12.1&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>' +
      'GigabitEthernet0/1&nbsp;&nbsp;10.0.13.1&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>',
  r2: 'Interface&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;IP-Address&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OK?&nbsp;Method&nbsp;Status&nbsp;&nbsp;&nbsp;Protocol<br>' +
      'GigabitEthernet0/0&nbsp;&nbsp;10.0.12.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>' +
      'GigabitEthernet0/1&nbsp;&nbsp;209.165.200.226&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>' +
      'GigabitEthernet0/2&nbsp;&nbsp;10.0.24.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>',
};

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/Static_Routing_Configuration_Sim_2.png',
      version: 'v1',
      selectedRouter: 'r1',
      totalScore: 0,

      r1: { mode: 'exec', routes: [], endDone: false },
      r2: { mode: 'exec', routes: [], endDone: false },

      v1R1Completion: { task1: false, task3: false, task4: false, saved: false },
      v1R2Completion: { task2: false, saved: false },
      v2R1Completion: { task2: false, task4: false, saved: false },
      v2R2Completion: { task1: false, task3: false, saved: false },

      r1Commands: {
        help:      () => createStdout(HELP_TEXT),
        enable:    () => createStdout(''),
        configure: (x) => this.iosConfigure(this.r1, x),
        conf:      (x) => this.iosConfigure(this.r1, x),
        exit:      () => this.iosExit(this.r1),
        end:       () => this.iosEnd(this.r1),
        ip:        (x) => this.iosIpRoute('r1', x),
        show:      (x) => this.iosShow('r1', x),
        copy:      (x) => this.iosCopy(this.r1, this.version === 'v1' ? this.v1R1Completion : this.v2R1Completion, x),
      },

      r2Commands: {
        help:      () => createStdout(HELP_TEXT),
        enable:    () => createStdout(''),
        configure: (x) => this.iosConfigure(this.r2, x),
        conf:      (x) => this.iosConfigure(this.r2, x),
        exit:      () => this.iosExit(this.r2),
        end:       () => this.iosEnd(this.r2),
        ip:        (x) => this.iosIpRoute('r2', x),
        show:      (x) => this.iosShow('r2', x),
        copy:      (x) => this.iosCopy(this.r2, this.version === 'v1' ? this.v1R2Completion : this.v2R2Completion, x),
      },
    };
  },

  computed: {
    r1Prompt() { return this.r1.mode === 'exec' ? 'R1#' : 'R1(config)#'; },
    r2Prompt() { return this.r2.mode === 'exec' ? 'R2#' : 'R2(config)#'; },

    v1Task1Done() { return this.v1R1Completion.task1; },
    v1Task2Done() { return this.v1R2Completion.task2; },
    v1Task3Done() { return this.v1R1Completion.task3; },
    v1Task4Done() { return this.v1R1Completion.task4; },
    v1SaveDone()  { return this.v1R1Completion.saved && this.v1R2Completion.saved; },

    v2Task1Done() { return this.v2R2Completion.task1; },
    v2Task2Done() { return this.v2R1Completion.task2; },
    v2Task3Done() { return this.v2R2Completion.task3; },
    v2Task4Done() { return this.v2R1Completion.task4; },
    v2SaveDone()  { return this.v2R1Completion.saved && this.v2R2Completion.saved; },
  },

  watch: {
    // V1 auto-switch
    v1Task1Done(val) { if (val && this.version === 'v1' && !this.v1R2Completion.task2) this.switchTo('r2'); },
    v1Task2Done(val) { if (val && this.version === 'v1' && !this.v1R1Completion.task3) this.switchTo('r1'); },
    'v1R1Completion.saved'(val) { if (val && this.version === 'v1' && !this.v1R2Completion.saved) this.switchTo('r2'); },

    // V2 auto-switch
    v2Task1Done(val) { if (val && this.version === 'v2' && !this.v2R1Completion.task2) this.switchTo('r1'); },
    v2Task2Done(val) { if (val && this.version === 'v2' && !this.v2R2Completion.task3) this.switchTo('r2'); },
    v2Task3Done(val) { if (val && this.version === 'v2' && !this.v2R1Completion.task4) this.switchTo('r1'); },
    'v2R1Completion.saved'(val) { if (val && this.version === 'v2' && !this.v2R2Completion.saved) this.switchTo('r2'); },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
  },

  methods: {
    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    switchTo(router) {
      this.selectedRouter = router;
      this.$nextTick(() => {
        const el = document.querySelector(`#${router}_terminal input, #${router}_terminal textarea`);
        if (el) el.focus();
      });
    },

    switchVersion(v) {
      if (this.version === v) return;
      this.version = v;
      this.r1.mode = 'exec';
      this.r1.routes = [];
      this.r1.endDone = false;
      this.r2.mode = 'exec';
      this.r2.routes = [];
      this.r2.endDone = false;
      this.selectedRouter = v === 'v2' ? 'r2' : 'r1';
      this.totalScore = 0;
      this.$emit('simulation_update_score', 0);
    },

    iosConfigure(state, x) {
      if (state.mode !== 'exec') return createStderr('% Invalid input detected');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        state.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(state) {
      if (state.mode === 'config') { state.mode = 'exec'; state.endDone = true; }
      return createStdout('');
    },

    iosEnd(state) {
      if (state.mode !== 'exec') state.endDone = true;
      state.mode = 'exec';
      return createStdout('');
    },

    iosIpRoute(routerKey, x) {
      const state = this[routerKey];
      if (state.mode !== 'config') return createStderr('% Invalid input detected');
      if (x._[1] !== 'route') return createStderr('% Invalid input detected');

      const dest    = x._[2];
      const mask    = x._[3];
      const nexthop = x._[4];
      const ad      = x._[5] !== undefined ? parseInt(x._[5]) : null;

      if (!dest || !mask || !nexthop) return createStderr('% Incomplete command');

      let guideMsg = '';

      if (this.version === 'v1') {
        if (routerKey === 'r1') {
          if (dest === '10.0.41.10' && mask === '255.255.255.255' && nexthop === '10.0.12.2' && !ad) {
            if (!this.v1R1Completion.task1) { this.v1R1Completion.task1 = true; this.updateScore(); }
            guideMsg = 'Host route to server 10.0.41.10/32 via R2 (10.0.12.2). A /32 mask targets exactly one IP address — the most specific match possible, so it is always preferred over broader subnets.';
          } else if (dest === '10.0.41.0' && mask === '255.255.255.0' && nexthop === '10.0.12.2' && ad === 254) {
            if (!this.v1R1Completion.task3) { this.v1R1Completion.task3 = true; this.updateScore(); }
            guideMsg = 'Floating static route to 10.0.41.0/24 via R2 with AD 254. The high AD keeps this route out of the routing table while the primary path (AD 1) is available — it only activates when the primary fails.';
          } else if (dest === '10.0.41.0' && mask === '255.255.255.0' && nexthop === '10.0.13.3' && !ad) {
            if (!this.v1R1Completion.task4) { this.v1R1Completion.task4 = true; this.updateScore(); }
            guideMsg = 'Primary route to R4 LAN 10.0.41.0/24 via R3 (10.0.13.3). With default AD 1, this route is preferred over the floating backup route (AD 254) via R2.';
          }
        }
        if (routerKey === 'r2') {
          if (dest === '0.0.0.0' && mask === '0.0.0.0' && nexthop === '209.165.200.225' && !ad) {
            if (!this.v1R2Completion.task2) { this.v1R2Completion.task2 = true; this.updateScore(); }
            guideMsg = 'Default route (0.0.0.0/0) to the ISP gateway 209.165.200.225. This catch-all route forwards any packet with no more-specific match toward the internet.';
          }
        }
      }

      if (this.version === 'v2') {
        if (routerKey === 'r1') {
          if (dest === '0.0.0.0' && mask === '0.0.0.0' && nexthop === '10.0.12.2' && !ad) {
            if (!this.v2R1Completion.task2) { this.v2R1Completion.task2 = true; this.updateScore(); }
            guideMsg = 'Default route on R1 pointing to R2 (10.0.12.2). R1 does not connect to the ISP directly — it forwards all unknown traffic to R2, which then routes it to the internet.';
          } else if (dest === '10.0.41.0' && mask === '255.255.255.0' && nexthop === '10.0.13.3' && !ad) {
            if (!this.v2R1Completion.task4) { this.v2R1Completion.task4 = true; this.updateScore(); }
            guideMsg = 'Route to R4 LAN 10.0.41.0/24 via R3 (10.0.13.3). R1 reaches the internal server subnet through R3 on its Gi0/1 interface.';
          }
        }
        if (routerKey === 'r2') {
          if (dest === '0.0.0.0' && mask === '0.0.0.0' && nexthop === '209.165.200.225' && !ad) {
            if (!this.v2R2Completion.task1) { this.v2R2Completion.task1 = true; this.updateScore(); }
            guideMsg = 'Default route on R2 to ISP gateway 209.165.200.225. R2 is the internet-facing router — all traffic leaving the enterprise exits through this path.';
          } else if (dest === '10.0.41.10' && mask === '255.255.255.255' && nexthop === '10.0.24.4' && !ad) {
            if (!this.v2R2Completion.task3) { this.v2R2Completion.task3 = true; this.updateScore(); }
            guideMsg = 'Host route to server 10.0.41.10/32 via R4 (10.0.24.4). The /32 mask ensures this specific server is reached through R2→R4, bypassing any less-specific routes.';
          }
        }
      }

      state.routes.push({ dest, mask, nexthop, ad });
      return guideMsg ? createStdout(this.guide(guideMsg)) : createStdout('');
    },

    iosShow(routerKey, x) {
      if (x._[1] === 'ip' && x._[2] === 'route') {
        const state = this[routerKey];
        if (state.routes.length === 0) return createStdout('% No routes configured');
        let out = 'Codes: S - static, C - connected<br><br>';
        state.routes.forEach((r) => {
          const adStr = r.ad ? `[${r.ad}/0]` : '[1/0]';
          const dest = r.dest === '0.0.0.0' ? 'S*   0.0.0.0/0' : `S    ${r.dest}/${r.mask === '255.255.255.255' ? '32' : '24'}`;
          out += `${dest} ${adStr} via ${r.nexthop}<br>`;
        });
        return createStdout(out);
      }
      if (x._[1] === 'ip' && x._[2] === 'interface' && x._[3] === 'brief') {
        return createStdout(IFACE_BRIEF[routerKey] || '% Interface information not available');
      }
      return createStderr('% Invalid input detected');
    },

    iosCopy(state, completion, x) {
      if (state.mode !== 'exec') return createStderr('% Invalid input detected');
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!completion.saved) { completion.saved = true; this.updateScore(); }
        return createStdout('Building configuration...<br>[OK]' + this.guide('Configuration saved to NVRAM. Running-config holds active settings in RAM; startup-config persists them across reboots.'));
      }
      return createStderr('% Invalid input detected');
    },

    updateScore() {
      let score = 0;
      if (this.version === 'v1') {
        Object.values(this.v1R1Completion).forEach((v) => { if (v) score++; });
        Object.values(this.v1R2Completion).forEach((v) => { if (v) score++; });
      } else {
        Object.values(this.v2R1Completion).forEach((v) => { if (v) score++; });
        Object.values(this.v2R2Completion).forEach((v) => { if (v) score++; });
      }
      this.totalScore = score;
      this.$emit('simulation_update_score', score);
      const max = this.version === 'v1' ? 6 : 6;
      if (score >= max) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },
  },

  components: { VueCommand },

  props: {
    data: { type: Object, required: true },
  },
};
</script>

<style>
#r1_terminal,
#r2_terminal {
  overflow: hidden !important;
}

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

